/**
 * Modified version of the remove-child-node-error-debugger package.
 * https://www.npmjs.com/package/remove-child-node-error-debugger
 * 
 * Original package is built for Next.js (commonJS)
 */

interface DomDebuggerOptions {
  highlightErrorNode?: boolean;
  logErrorNodeToConsole?: boolean;
}

const defaultOptions: DomDebuggerOptions = {
  highlightErrorNode: true,
  logErrorNodeToConsole: true,
};

function highlightElement<T extends Node>(element: T): T {
  if (element && element instanceof HTMLElement && element.style) {
    element.style.border = `0.5px solid tomato`;
    element.style.backgroundColor = 'rgba(255, 0, 0, 0.1)';
  }
  return element;
}

function logError(message: string, ...args: (Node | string)[]) {
  console.log(`${message}`, ...args);
}

function overrideRemoveChild(options: DomDebuggerOptions) {
   
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (options.logErrorNodeToConsole) {
        logError('Cannot remove a child from a different parent', child, this);
      }
      if (options.highlightErrorNode) {
        highlightElement(child);
        highlightElement(this);
      }
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };
}

function overrideInsertBefore(options: DomDebuggerOptions) {
   
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (options.logErrorNodeToConsole) {
        logError(
          'Cannot insert before a reference node from a different parent',
          referenceNode,
          this
        );
      }
      if (options.highlightErrorNode) {
        highlightElement(newNode);
        highlightElement(this);
      }
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}

function domNodeDebugger(userOptions: DomDebuggerOptions = {}) {
  const options = { ...defaultOptions, ...userOptions };

  if (typeof window === 'undefined' || typeof Node === 'undefined') {
    console.warn('This debugger is intended for browser environments only.');
    return;
  }

  if (typeof Node === 'function' && Node.prototype) {
    overrideRemoveChild(options);
    overrideInsertBefore(options);
  } else {
    logError('Node.prototype is not available. Debugging cannot be enabled.');
  }
}

export default domNodeDebugger;
